import moment from 'moment';
import immJs from 'lodash';

function EventReducer(state = {}, action) {
  const newState = immJs.cloneDeep(state);
  let { eventsById, eventsByDate, externalCalendarSlots, freeSlotsByDate } = newState;
  if (!eventsById) {
    eventsById = {};
    eventsByDate = {};
  }
  if (!freeSlotsByDate) freeSlotsByDate = {};
  externalCalendarSlots = [];
  const events = action.payload;
  let date;
  let startDate;
  let endDate;
  let startTime;
  let endTime;
  let eventIds;
  let index;
  let temp;
  switch (action.type) {
    case 'GET_ARYA_EVENTS':
      startDate = moment.utc(action.startTime).local().startOf('day');
      date = startDate;
      endDate = moment.utc(action.endTime).local().startOf('day');
      while (date <= endDate) {
        eventsByDate[date.format('DDMMYYYY')] = [];
        date = moment(date).add(1, 'days');
      }
      for (let i = 0; i < events.length; i += 1) {
        eventsById[events[i].EventId] = events[i];
        startTime = moment.utc(events[i].StartTime).local().startOf('day');
        date = startTime;
        if (date < startDate) {
          date = startDate;
        }
        endTime = moment.utc(events[i].EndTime).local().startOf('day');
        if (endTime > endDate) {
          endTime = endDate;
        }
        while (date <= endTime) {
          eventsByDate[date.format('DDMMYYYY')].push(events[i].EventId);
          date = moment(date).add(1, 'days');
        }
      }
      newState.eventsById = eventsById;
      newState.eventsByDate = eventsByDate;
      return {
        ...state,
        ...newState,
      };
    case 'GET_BUSY_SLOTS':
      externalCalendarSlots = [];
      for (let i = 0; i < action.payload.length; i += 1) {
        externalCalendarSlots.push(action.payload[i]);
      }
      newState.externalCalendarSlots = externalCalendarSlots;
      return {
        ...state,
        ...newState,
      };
    case 'ACCEPT_OR_DECLINE_EVENT':
      eventsById[events.EventId].Status = events.Status;
      eventsById[events.EventId].StartTime = events.StartTime;
      eventsById[events.EventId].EndTime = events.EndTime;
      eventsById[events.EventId].Attendees = events.Attendees;
      newState.eventsById = eventsById;
      return {
        ...state,
        ...newState,
      };
    case 'PROPOSE_EVENT':
      startTime = moment.utc(eventsById[events.EventId].StartTime).local().startOf('day');
      endTime = moment.utc(eventsById[events.EventId].EndTime).local().startOf('day');
      date = startTime;
      while (date <= endTime) {
        index = eventsByDate[date.format('DDMMYYYY')].indexOf(events.EventId);
        eventsByDate[date.format('DDMMYYYY')].splice(index, 1);
        date = moment(date).add(1, 'days');
      }
      startTime = moment.utc(events.StartTime).local().startOf('day');
      endTime = moment.utc(events.EndTime).local().startOf('day');
      date = startTime;
      while (date <= endTime) {
        if (eventsByDate[date.format('DDMMYYYY')] === undefined) {
          eventsByDate[date.format('DDMMYYYY')] = [];
        }
        eventsByDate[date.format('DDMMYYYY')].push(events.EventId);
        date = moment(date).add(1, 'days');
      }
      eventsById[events.EventId].Status = events.Status;
      eventsById[events.EventId].StartTime = events.StartTime;
      eventsById[events.EventId].EndTime = events.EndTime;
      eventsById[events.EventId].Attendees = events.Attendees;
      eventIds = eventsByDate[moment.utc(events.StartTime).local().format('DDMMYYYY')];
      index = eventIds.indexOf(events.EventId);
      if (index > 0 && eventsById[eventIds[index]].StartTime < eventsById[eventIds[index - 1]].StartTime) {
        let i = index - 1;
        while (i >= 0 && eventsById[eventIds[i]].StartTime > eventsById[eventIds[i + 1]].StartTime) {
          temp = eventIds[i + 1];
          eventIds[i + 1] = eventIds[i];
          eventIds[i] = temp;
          i -= 1;
        }
      } else if (
        index < eventIds.length - 1 &&
        eventsById[eventIds[index]].StartTime > eventsById[eventIds[index + 1]].StartTime
      ) {
        let i = index + 1;
        while (i < eventIds.length && eventsById[eventIds[i]].StartTime < eventsById[eventIds[i - 1]].StartTime) {
          temp = eventIds[i - 1];
          eventIds[i - 1] = eventIds[i];
          eventIds[i] = temp;
          i += 1;
        }
      }
      eventsByDate[moment.utc(events.StartTime).local().format('DDMMYYYY')] = eventIds;
      newState.eventsByDate = eventsByDate;
      newState.eventsById = eventsById;
      return {
        ...state,
        ...newState,
      };
    case 'CREATE_EVENT':
      startTime = moment.utc(events.StartTime).local().startOf('day');
      endTime = moment.utc(events.EndTime).local().startOf('day');
      date = startTime;
      events.EventId = action.eventId;
      eventsById[action.eventId] = events;
      while (date <= endTime) {
        if (eventsByDate[date.format('DDMMYYYY')] === undefined) {
          eventsByDate[date.format('DDMMYYYY')] = [];
        }
        eventsByDate[date.format('DDMMYYYY')].push(action.eventId);
        date = moment(date).add(1, 'days');
      }
      eventIds = eventsByDate[moment.utc(startTime).local().format('DDMMYYYY')];
      index = eventIds.length - 1;
      if (index > 0 && eventsById[eventIds[index]].StartTime < eventsById[eventIds[index - 1]].StartTime) {
        let i = index - 1;
        while (i >= 0 && eventsById[eventIds[i]].StartTime > eventsById[eventIds[i + 1]].StartTime) {
          temp = eventIds[i + 1];
          eventIds[i + 1] = eventIds[i];
          eventIds[i] = temp;
          i -= 1;
        }
      } else if (
        index < eventIds.length - 1 &&
        eventsById[eventIds[index]].StartTime > eventsById[eventIds[index + 1]].StartTime
      ) {
        let i = index + 1;
        while (i < eventIds.length && eventsById[eventIds[i]].StartTime < eventsById[eventIds[i - 1]].StartTime) {
          temp = eventIds[i - 1];
          eventIds[i - 1] = eventIds[i];
          eventIds[i] = temp;
          i += 1;
        }
      }
      eventsByDate[moment.utc(events.StartTime).local().format('DDMMYYYY')] = eventIds;
      newState.eventsById = eventsById;
      newState.eventsByDate = eventsByDate;
      return {
        ...state,
        ...newState,
      };
    case 'DELETE_EVENT':
      startTime = moment.utc(events.StartTime).local().startOf('day');
      endTime = moment.utc(events.EndTime).local().startOf('day');
      date = startTime;
      while (date <= endTime) {
        index = eventsByDate[date.format('DDMMYYYY')].indexOf(events.EventId);
        eventsByDate[date.format('DDMMYYYY')].splice(index, 1);
        date = moment(date).add(1, 'days');
      }
      delete newState.eventsById[events.EventId];
      return {
        ...state,
        ...newState,
      };
    case 'SET_FREE_SLOTS_LOADING_STATUS':
      newState.isFreeSlotsLoading = action.payload;
      return {
        ...state,
        ...newState,
      };
    case 'GET_FREE_SLOTS':
      newState.freeSlots = action.payload;
      return {
        ...state,
        ...newState,
      };
    case 'ADD_FREE_SLOTS_BY_DATE':
      newState.freeSlotsByDate = { ...freeSlotsByDate, ...action.payload };
      return {
        ...state,
        ...newState,
      };
    case 'SET_EVENT_BY_ID':
      newState.eventsById = {
        ...newState.eventsById,
        [action.payload.eventId]: action.payload.event,
      };
      return {
        ...state,
        ...newState,
      };
    default:
      return { ...state };
  }
}

function getEventsById(state) {
  return state.EventReducer.eventsById;
}

function getEventsByDate(state) {
  return state.EventReducer.eventsByDate;
}

function getExternalCalendarSlots(state) {
  return state.EventReducer.externalCalendarSlots;
}

function getFreeSlotsLoadingStatus(state) {
  return state.EventReducer.isFreeSlotsLoading;
}

function getFreeSlots(state) {
  return state.EventReducer.freeSlots;
}

function getFreeSlotsByDate(state) {
  return state.EventReducer.freeSlotsByDate;
}

export {
  EventReducer,
  getEventsById,
  getEventsByDate,
  getExternalCalendarSlots,
  getFreeSlotsLoadingStatus,
  getFreeSlots,
  getFreeSlotsByDate,
};
